import { defineComponent as r, computed as o, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "d5a14bcd-4b8e-460c-8d39-a05b271213cd" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#d5a14bcd-4b8e-460c-8d39-a05b271213cd)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#d80027" d="M0 0h512v133.7l-52 126 52 118.8V512H0V378.5l53-121L0 133.6z"></path><path fill="#eee" d="M0 133.7h512v244.8H0z"></path><path fill="#ffda44" d="M345 256.1c0 49.2-39.8 78-89 78s-89-28.8-89-78a89 89 0 1 1 178 0z"></path><path fill="#0052b4" d="M345 256.1a89 89 0 1 1-178 0"></path><path fill="#d80027" d="M200.3 233.8h22.3v44.6h-22.3zm89 0h22.4v44.6h-22.3zM245 200.4h22v78h-22z"></path>', 5), g = { fill: "none" }, x = ["r"], y = /* @__PURE__ */ r({
  __name: "pf",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), d = o(() => 256 + e.strokeWidth / 2);
    return (z, b) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (s(), c("title", k, h(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=pf-3922e6ba.js.map
